// Server-only constants.
// IMPORTANT: Do NOT import this module from client/browser code.

export const PRINTFUL_API_BASE_URL = 'https://api.printful.com';

// Credits
// We use a single credit balance. Users start with 100 credits.
export const DEFAULT_CREDITS = 100;

// KV keys
export const PRINTFUL_PRICE_KEY_PREFIX = 'printful:variant-price:';

// Aggregated key to avoid KV fan-out reads in public endpoints.
export const ALL_VARIANT_PRICES_KEY = 'printful:variant-prices:all';

export const FX_KV_KEY = 'fx:usd_to_cad';
export const FX_TTL_SECONDS = 60 * 60 * 6; // 6 hours

// Browser storage keys (kept here so we can reuse across hooks/services consistently).
// NOTE: Although these are used in browser code, we keep them in a server/constants module
// only if you *never* import this file from the client bundle. If you prefer stricter
// separation, we can move these into root constants.ts instead.
export const CURRENCY_STORAGE_KEY = 'homeart:currency';
export const CURRENCY_STORAGE_LOCK_KEY = 'homeart:currencyUserSet';
